// semeia-disable-reexport
import type { PracticeLocation } from "parog-web/cnam/types";

export function practiceLocationIndex(
  selectedPracticeLocation: string | undefined,
  availablePracticeLocations: Array<PracticeLocation>
): number {
  return availablePracticeLocations?.findIndex(
    location =>
      location.structureName?.toUpperCase() ==
      selectedPracticeLocation?.toUpperCase()
  );
}
